/* eslint-disable consistent-return */
/* eslint-disable react/no-danger */
/* eslint-disable react/require-default-props */
import { Box } from "@mui/material";
import React from "react";
import ModalImage from "react-modal-image";
import ReactAudioPlayer from "react-audio-player";
import { FormattedMessage } from "react-intl";

type TProps = {
  ele?: any;
  index?: number;
  ix?: number;
};
function SwitchDataContent({ ele, ix, index = 0 }: TProps) {
  const renderOrdinalQuestion = () => {
    if (Number.isInteger(index) && Number.isInteger(ix) && ix === 0) {
      return (
        <span style={{ whiteSpace: "nowrap", marginTop: 8 }} className="font-semibold">
          <FormattedMessage id="ISD_Question_Ordinal" values={{ ordinal: index + 1 }} />
          &nbsp;
        </span>
      );
    }
    return "";
  };

  switch (ele.content_type) {
    case "image":
      return (
        <>
          {renderOrdinalQuestion()}
          <Box my={2} display="flex" justifyContent="center" alignItems="center" className="font-[400]">
            <ModalImage
              small={ele?.content}
              large={ele?.content}
              hideDownload
              hideZoom
              style={{
                // height: 200,
                objectFit: "contain"
              }}
              alt="thitot.vn"
            />
          </Box>
        </>
      );
    case "audio":
      return (
        <>
          {renderOrdinalQuestion()}
          <Box my={1} display="flex" justifyContent="center" height="54px">
            <ReactAudioPlayer src={ele?.content} controls />
          </Box>
        </>
      );
    default:
      return (
        <Box className="sm:block md:flex flex-col" alignItems="baseline">
          {renderOrdinalQuestion()}
          {ele?.content && (
            // eslint-disable-next-line
            <div className="sm:mr-[10px] md:mr-0" dangerouslySetInnerHTML={{ __html: ele?.content }} />
          )}
        </Box>
      );
  }
}

export default React.memo(SwitchDataContent);
